angular.module("toggle-switch", ["ng"]).directive("toggleSwitch", function () {
    return {
        restrict: "EA",
        replace: !0,
        scope: {
            model: "=",
            reversed: "@",
            disabled: "@",
            onLabel: "@",
            offLabel: "@",
            knobLabel: "@"
        },
        template:
            '<div class="switch" ng-click="toggle()" ng-class="{ \'disabled\': disabled }"><div class="switch-animate" ng-class="{\'switch-off\': ( reversed ? model : !model ), \'switch-on\': ( reversed ? !model : model)}"><span class="switch-left" ng-bind="onLabel"></span><span class="knob" ng-bind="knobLabel"></span><span class="switch-right" ng-bind="offLabel"></span></div></div>',
        controller: [
            "$scope",
            function ($scope) {
                $scope.toggle = function () {
                    $scope.disabled || ($scope.model = !$scope.model);
                };
            }
        ],
        compile: function (element, attrs) {
            (attrs.onLabel || (attrs.onLabel = "On"),
                attrs.offLabel || (attrs.offLabel = "Off"),
                attrs.knobLabel || (attrs.knobLabel = " "),
                attrs.disabled || (attrs.disabled = !1));
        }
    };
});
